<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_associations') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('support.support_createTicket_theme') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.topic)  }}
        game-preview-setting
          span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_subTopics') }}
          span(slot="value") {{ subTopics }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
            span(slot="value") {{ parameters.difficult.amountOfRows + ' x ' + parameters.difficult.amountOfColumns }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            subTopics() {
                return this.parameters.selectedSubTopics
                    .map(subTopic => this.$i18n.t('trainer.trainer_gameFormSettingValue_' + `${subTopic}`))
                    .join('; ');
            },
        },
    };
</script>
